/* eslint-disable no-unused-vars */
import API from "../api";
import router from "@/router";
import jwt_decode from "jwt-decode";

export const X_AUTH_TOKEN = "x-auth-token";
export const X_AUTH_DATA_EXPIRACAO = "x-auth-data-expiracao";

export const X_CONTEXT_DEPARTAMENTO = "x-context-departamento";
export const X_CONTEXT_MODULO = "x-context-modulo";
export const X_REFRESH_TOKEN = "x-refresh-token";
export const X_AUTH_PERMISSIONS = "x-auth-permissions";


export async function primeiroLogin(form) {

    const { data } = await API.post("/api/login/primeiro-login", {
        username: form.username,
        password: form.password,
    });

    return data;

}

export async function alterarSenha(form) {

    const { data, headers } = await API.put("/api/login/primeiro-login-alterar-senha", {
        username: form.username,
        password: form.password,
        newPassword:form.newPassword
    });
}


export async function login(form) {

    const { data, headers } = await API.post("/api/login", {
        username: form.username,
        password: form.password,
    });

    data.usuario.privilegios = data.permissoes;
    data.usuario.modulos = data.modulos;
    setToken(data.token);
    setPermissoes(data.permissoes);
    setModulos(data.modulos);
    setDataExpiracao(data.dataExpiracaoToken)

    setContext({ usuario: data.usuario });
    setContext({ departamento: data.departamento });

}

function setContext(obj) {
    const context = localStorage.getItem("context");
    const newContext =
        context && context !== "undefined"
            ? { ...JSON.parse(context), ...obj }
            : obj;

    localStorage.setItem("context", JSON.stringify(newContext));
}

export function getContext() {
    const context = localStorage.getItem("context");

    return JSON.parse(context);
}

export function hasContext(key) {
    const context = localStorage.getItem("context");

    return !!JSON.parse(context || "{}")[key];
}

function removeContext() {
    localStorage.removeItem("context");
}

export const guardAuthRoute = (to, from, next) => {
    try {
        tokenDecoded() ? next() : next({ name: "Login" });
    } catch (e) {
        next({ name: "Login" });
    }
};

export const guardAdminRoute = (to, from, next) => {
    try {
        isUserAdmin() ? next() : next({ name: "Unauthorized" });
    } catch (e) {
        next({ name: "Login" });
    }
};

export const updateTokensFromHeaders = headers => {
    if (headers[X_AUTH_TOKEN]) {
        setToken(headers[X_AUTH_TOKEN]);
    }
    // if (headers[X_REFRESH_TOKEN]) {
    //   setRefreshToken(headers[X_REFRESH_TOKEN]);
    // }
    // if (headers[X_CONTEXT_DEPARTAMENTO]) {
    //   setContext({ departamento: JSON.parse(headers[X_CONTEXT_DEPARTAMENTO]) });
    // }
};

export const getUsuario = () => getContext().usuario;

export const getDepartamento = () => getContext().departamento;

export const getToken = () => localStorage.getItem(X_AUTH_TOKEN);

export const setToken = token => localStorage.setItem(X_AUTH_TOKEN, token);


export const getDataExpiracao = () => localStorage.getItem(X_AUTH_DATA_EXPIRACAO);

export const setDataExpiracao = data => localStorage.setItem(X_AUTH_DATA_EXPIRACAO, data);

export const setPermissoes = permissoes =>
    localStorage.setItem(X_AUTH_PERMISSIONS, JSON.stringify(permissoes));


export const setModulos = modulos =>
    localStorage.setItem(X_CONTEXT_MODULO, JSON.stringify(modulos));

export const getModulos = () =>
    JSON.parse(localStorage.getItem(X_CONTEXT_MODULO) && localStorage.getItem(X_CONTEXT_MODULO) != "undefined" ? localStorage.getItem(X_CONTEXT_MODULO) : null);

export const getPermissoes = () =>
    JSON.parse(localStorage.getItem(X_AUTH_PERMISSIONS) && localStorage.getItem(X_AUTH_PERMISSIONS) != "undefined" ? localStorage.getItem(X_AUTH_PERMISSIONS) : null);

export const possuiPermissao = (permissao) =>
    JSON.parse(localStorage.getItem(X_AUTH_PERMISSIONS)).filter(item => item == permissao).length > 0;

export function setDepartamento(departamento) {
    setContext({ departamento: departamento });
}


export function logout(callback) {
    localStorage.removeItem(X_AUTH_TOKEN);
    removeContext();
    callback ? callback() : router.replace("/login");
}

export function isLogged() {
    return !!localStorage.getItem(X_AUTH_TOKEN);
}

export function isUserAdmin() {
    try {
        return tokenDecoded().admin;
    } catch (_) {
        return false;
    }
}

export function tokenDecoded() {
    return jwt_decode(getToken());
}
